<script>
import {mapActions, mapGetters} from 'vuex'
import profile from '../store/modules/profile'
import Avv from "@/views/AvvView.vue"
import AvvCheckbox from '@/components/common/Avv.vue'
import BaseDataForm from "@/components/profile/billingData/BaseDataForm.vue"
import ChangeEmail from "@/components/profile/accountManagement/ChangeEmail.vue"
import ChangePassword from "@/components/profile/accountManagement/ChangePassword.vue"
import DeleteAccount from "@/components/profile/accountManagement/DeleteAccount.vue"
import EmailNotifications from "@/components/profile/generally/EmailNotifications.vue"
// import Language from "@/components/profile/Language.vue"
// import Theme from "@/components/profile/Theme.vue"
// import GDPR from "@/components/profile/GDPR.vue"

export default {
  components: {
    EmailNotifications,
    ChangeEmail,
    ChangePassword,
    DeleteAccount,
    BaseDataForm,
    Avv,
    AvvCheckbox,
    // GDPR,
    // Language,
    // Theme
  },
  data() {
    return {
      activeTab: 0
    }
  },
  computed: {
    profile() {
      return profile
    },
    ...mapGetters(['isLocked']),
  },
  created() {
    this.activeTab = this.tabName
  },
  methods: {
    ...mapActions(['getUserSettings'])
  }
}
</script>
<template>
  <v-container fluid>
    <v-card>
      <v-tabs v-model="activeTab" show-arrows>
        <v-tabs-slider></v-tabs-slider>
        <v-tab>
          <v-icon>mdi-account-outline</v-icon>
          <span class="pl-1">{{$t('navigation.views.userProfile.tab.personal.data')}}</span>
        </v-tab>
<!--        <v-tab>-->
<!--          <v-icon>mdi-translate</v-icon>-->
<!--          <span class="pl-1">Sprache</span>-->
<!--        </v-tab>-->
<!--        <v-tab>-->
<!--          <v-icon>mdi-compare</v-icon>-->
<!--          <span class="pl-1">{{$t('navigation.views.userProfile.tab.billing.data')}}</span>-->
<!--        </v-tab>-->
        <v-tab>
          <v-icon>mdi-bell-outline</v-icon>
          <span class="pl-1">{{$t('navigation.views.userProfile.tab.notifications')}}</span>
        </v-tab>
        <v-tab>
          <v-icon>mdi-shield-lock-outline</v-icon>
          <span class="pl-1">{{$t('navigation.views.userProfile.tab.terms.of.service')}}</span>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="activeTab">
        <v-tab-item>
          <v-divider/>
          <v-container fluid>
            <v-tabs vertical class="pt-4">
              <v-tab class="justify-start">
                <v-icon left>mdi-account-cash-outline</v-icon>
                <span>{{$t('navigation.views.userProfile.tab.billing.data')}}</span>
              </v-tab>
              <v-tab class="justify-start">
                <v-icon left>mdi-lock-check-outline</v-icon>
                <span>{{$t('navigation.views.userProfile.tab.change.password')}}</span>
              </v-tab>
              <v-tab class="justify-start">
                <v-icon left>mdi-account-outline</v-icon>
                <span>{{$t('navigation.views.userProfile.tab.change.email')}}</span>
              </v-tab>
<!--              <v-tab class="justify-start">-->
<!--                <v-icon left>mdi-lock</v-icon>-->
<!--                <span>{{$t('navigation.views.userProfile.tab.privacy.policy')}}</span>-->
<!--              </v-tab>-->
              <v-tab v-if="!$permissions.hasSkipPayment" class="justify-start">
                <v-icon left>mdi-account-outline</v-icon>
                <span>{{$t('navigation.views.userProfile.tab.delete.account')}}</span>
              </v-tab>
              <v-tab-item>
                <BaseDataForm/>
              </v-tab-item>
              <v-tab-item>
                <ChangePassword/>
              </v-tab-item>
              <v-tab-item>
                <ChangeEmail/>
              </v-tab-item>
<!--              <v-tab-item>-->
<!--                <GDPR/>-->
<!--              </v-tab-item>-->
              <v-tab-item v-if="!$permissions.hasSkipPayment">
                <DeleteAccount/>
              </v-tab-item>
            </v-tabs>
          </v-container>
        </v-tab-item>
<!--        <v-tab-item>-->
<!--          <v-divider/>-->
<!--          <v-container fluid>-->
<!--            <v-row>-->
<!--              <v-col>-->
<!--                <Language/>-->
<!--              </v-col>-->
<!--            </v-row>-->
<!--          </v-container>-->
<!--        </v-tab-item>-->
<!--        <v-tab-item>-->
<!--          <v-divider/>-->
<!--          <v-container fluid>-->
<!--            <v-row>-->
<!--              <v-col>-->
<!--                <Theme/>-->
<!--              </v-col>-->
<!--            </v-row>-->
<!--          </v-container>-->
<!--        </v-tab-item>-->
        <v-tab-item>
          <v-divider/>
          <v-container fluid>
            <v-row>
              <v-col>
                <EmailNotifications/>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-divider/>
          <Avv/>
          <v-container fluid>
            <v-row>
              <v-col>
                <!-- @TODO: fix display-->
                <AvvCheckbox
                  :hide-title="true"
                  :hide-submit="true"
                  :set-avv-checkbox="true"/>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>
